import React, { useMemo } from 'react';
import PickupOperatorApi from '../PickupOperatorApi';
import PickupOperatorSettings from '../PickupOperatorSettings';
import DropMenu from '@dex/bubl-dash/src/lib/components/DropMenu/DropMenu';
import Link from '@dex/bubl-dash/src/lib/components/Link/Link';

const PickupOperatorActions: React.FC<any> = (props: any) => {

    const { data } = props;

    const del = PickupOperatorApi.delete(data.id, {
        onComplete: (response) => {

            if (data.modelName && data.id) {
                const event = new CustomEvent(data.modelName + data.id, { detail: 'deleted' });
                window.dispatchEvent(event);
            }

        }
    });

    return useMemo(() => {

        return (

            <DropMenu>

                <Link
                    path={`${ PickupOperatorSettings.path }/${data.id}/view`}
                >
                    View
                </Link>

                <Link
                    path={`${ PickupOperatorSettings.path }/${data.id}/edit`}
                >
                    Edit
                </Link>

                <Link
                    confirm={ {
                        title: `Delete ${ data[PickupOperatorSettings.primaryKey] }`,
                        message: "Are your sure you want to perform this action?"
                    } }
                    onClick={del.run}
                >
                    Delete
                </Link>

            </DropMenu>

        )

    }, [data, del]);

}

export default PickupOperatorActions;
